var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.wrapper},[(!_vm.disabled)?_c('ul',{class:_vm.$style.header},_vm._l((_vm.tabs),function(tab,index){return _c('li',{key:tab.title,class:[
        _vm.$style.tab,
        index === _vm.selectedIndex ? _vm.$style.selected : _vm.$style.notSelected,
      ],attrs:{"data-test-id":"tabComponent"},on:{"click":function($event){return _vm.selectTab(index)}}},[_c('div',{class:_vm.$style.tabTitle},[_vm._v(_vm._s(tab.title))])])}),0):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }